<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="col">
                    <h5 class="mb-4">
                        <strong>Registro de fallos</strong>
                    </h5>
                </div>
                <b-row>
                    <b-col class="mx-3">
                        <b-table id="my-table" v-if="bugs.length !== 0" striped hover :fields="columns" :items="bugs"
                            head-variant="light" responsive>
                            <template #cell(createdAt)="bugs">
                                <div>
                                    {{ moment(bugs.item.createdAt).locale('es').format('YYYY-MM-DD hh:mm a') }}
                                </div>
                            </template>
                            <template #cell(actions)="bugs">
                                <div>
                                    <a-tooltip placement="top">
                                        <template slot="title">
                                            <span>Ver información</span>
                                        </template>
                                        <button type="button" @click="seeBug(bugs.item)" class="btn btn-light mr-2">
                                            <i class="fa fa-eye" />
                                        </button>
                                    </a-tooltip>
                                    <a-tooltip placement="top">
                                        <template slot="title">
                                            <span>Eliminar</span>
                                        </template>
                                        <button type="button" v-on:click="deleteBug(bugs.item.id)"
                                            class="btn btn-light mr-2">
                                            <i class="fa fa-times-circle text-red" />
                                        </button>
                                    </a-tooltip>
                                </div>
                            </template>
                        </b-table>
                        <empty-table v-else />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-pagination v-model="pagination.currentPage" :total-rows="pagination.rows"
                            :per-page="pagination.perPage" @input="loadBugs()" aria-controls="my-table"></b-pagination>
                    </b-col>
                    <b-col class="text-right">
                        {{ pagination.rows }} resultados
                    </b-col>
                </b-row>
                <b-modal id="modal-bug" ref="modal" hide-footer title="Detalle del fallo" size="lg">
                    <div class="p-3">
                        <p>ID de la institución educativa que presentó el fallo: {{ this.bug.idSchool }}</p>
                        <p>Usuario: {{ this.bug.idUser }}</p>
                        <p>El bug se presentó el {{ moment(this.bug.createdAt).locale('es').format('LLLL') }}</p>
                        <p>Código de estado Http: {{ this.bug.statusCode }}</p>
                        <p>Stack: {{ this.bug.stack }}</p>
                        <p>{{ this.bug.info ? `Información: ${this.bug.info}` : ''}}</p>
                        <p>Nombre del error: {{ this.bug.name }}</p>
                    </div>
                    <b-button size="sm" class="mr-3 float-right"
                        @click="() => { this.$bvModal.hide('modal-bug') }">Cerrar
                    </b-button>
                </b-modal>
            </div>
        </div>
    </div>
</template>
<script>
import emptyTable from '@/components/custom/cardEmptyList'
import moment from 'moment'
import apiClient2 from '@/services/axios/v2'
import { ToastFire } from '@/services/utilities/swal'

export default {
  name: 'registerErrors',
  components: { emptyTable },
  data() {
    return {
      moment,
      bugs: [],
      columns: [
        { key: 'idSchool', label: 'Colegio' },
        { key: 'error', label: 'Error' },
        { key: 'message', label: 'Mensaje' },
        { key: 'statusCode', label: 'Codigo de estado Http' },
        { key: 'createdAt', label: 'Fecha' },
        { key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'text-center' },
      ],
      pagination: {
        rows: 0,
        perPage: 10,
        currentPage: 1,
      },
      bug: {},
    }
  },
  created() {
    this.loadBugs()
  },
  methods: {
    loadBugs() {
      const form = {
        page: this.pagination.currentPage - 1,
        perPage: this.pagination.perPage,
      }
      apiClient2.get('/bugs', { params: form }).then((response) => {
        this.bugs = response.data.data.rows
        this.pagination.rows = response.data.data.count
      }).catch(e => {
        ToastFire('warning', e.response.data.error.message)
      })
    },
    deleteBug(id) {
      apiClient2.delete(`/bugs/${id}`).then((response) => {
        this.bugs = this.bugs.filter((item) => item.id !== id)
        ToastFire('success', 'Registro eliminado exitosamente!')
      }).catch(e => {
        ToastFire('warning', e.response.data.error.message)
      })
    },
    seeBug(item) {
      this.bug = item
      this.$bvModal.show('modal-bug')
    },
  },
}

</script>
